<template>
  <div id="opdashboard">
    <Fieldset class="p-shadow-8">
      <template #legend>
        <Dropdown
          class="p-shadow-8"
          v-model="form.bumper"
          :options="admins"
          optionLabel="AdminNo"
          optionValue="AdminNo"
          placeholder="Select a Bumper#"
          :filter="true"
          filterPlaceholder="Find Bumper #"
        />
      </template>
      <form>
        <div>
          <Checkbox id="offpost" v-model="offpost" :binary="true" />
          <label for="offpost"><b class="p-ml-2">Off Post Dispatch</b></label>
        </div>

        <br />

        <b>Select the dates for this dispatch</b><br />

        <Calendar
          class="p-mt-2"
          id="range"
          v-model="dates2"
          selectionMode="range"
          :manualInput="true"
          :showIcon="true"
        />

        <br />

        <!-- When date selected, the admin # selected should be checked for a PMCS completed in the past 24 hours -->

        <InputText
          style="width: 238px"
          class="p-mt-2"
          id="location"
          type="text"
          placeholder="Reason and Destination"
        />

        <!-- <br/>
    <label for="operator1" style="width:125px" >1st Operator GCSS #</label> -->
        <br />
        <InputText
          id="operator1"
          style="width: 238px"
          class="box p-mt-2"
          type="text"
          v-model="user.persno"
          placeholder="1st Operators Persn.#"
        />

        <br />

        <!-- <label for="operator2" class="p-col-fixed" style="width:125px" >2nd Operator GCSS #</label> -->

        <InputText
          class="p-mt-2"
          id="operator2"
          style="width: 238px"
          type="text"
          placeholder="2nd Operators persn.#"
        />

        <br />

        <Textarea
          class="p-m-2"
          style="width: 238px"
          v-model="comments"
          :autoResize="true"
          rows="5"
          cols="30"
          placeholder="type comments to the distpatcher here..."
        />

        <br />

        <!-- <Button
          class="p-m-3 p-shadow-8"
          icon="pi pi-check-circle"
          label="Submit"
          type="submit"
        /> -->
      </form>
      <div v-show="submitted">
        <p>Your dispatch has been submitted to the Clerks!</p>
        <p>You must complete a PMCS, and link up with the Mechanics for a QA/QC!</p>
      </div>
    </Fieldset>
  </div>
</template>

<script>
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import Fieldset from "primevue/fieldset";
import Dropdown from "primevue/dropdown";
import Checkbox from "primevue/checkbox";
import Calendar from "primevue/calendar";
import { fb_auth, fb_db, fb_dispatch } from "../firebase";
import bumpers from "@/assets/AdminNo.js";

export default {
  name: "OpDashboard",
  components: {
    Dropdown,
    Fieldset,
    InputText,
    Checkbox,
    Calendar,
    Textarea,
  },
  created() {
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let prevMonth = month === 0 ? 11 : month - 1;
    let prevYear = prevMonth === 11 ? year - 1 : year;
    let nextMonth = month === 11 ? 0 : month + 1;
    let nextYear = nextMonth === 0 ? year + 1 : year;
    this.minDate = new Date();
    this.minDate.setMonth(prevMonth);
    this.minDate.setFullYear(prevYear);
    this.maxDate = new Date();
    this.maxDate.setMonth(nextMonth);
    this.maxDate.setFullYear(nextYear);

    let invalidDate = new Date();
    invalidDate.setDate(today.getDate() - 1);
    this.invalidDates = [today, invalidDate];
  },
  data() {
    return {
      offpost: false,
      form: {
        bumper: null,
        offpost: null,
        someDate: null,
        range: null,
        dates2: null,
        operator1: null,
        operator2: null,
        comments: null,
      },
    };
  },
  async mounted() {
    this.$store.dispatch("getAdmins");
  },
  methods: {
    submitDispatch() {
      fb_dispatch
        .add({
          admin: this.bumper,
          offpost: this.offpost,
          range: this.range,
          operator1: this.operator1,
          operator2: this.operator2,
          comments: this.comments,
          user: fb_db.collection("users").doc(fb_auth.currentUser.uid),
        })
        .then(() => {
          this.submitted = true;
        });
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    userProfile() {
      return this.$store.state.userProfile;
    },
    user() {
      return this.userProfile;
    },
    admins() {
      return this.$store.state.admins;
    },
  },
};
</script>

<style lang="scss" scoped>
#dashboard {
  color: #999999;
}
</style>